import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { PageContainer } from "@outpave/ds";
import CardProgramsTable from "components/admin/settings/CardPrograms/CardProgramsTable";
import { useCheckUserRole } from "hooks/useCheckUserRole";
import { useNavBreadcrumbs } from "hooks/useNavBreadcrumbs";
import Role from "enums/Role";

const CardPrograms: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumbs = useNavBreadcrumbs(t("Card programs"));
  const isAdmin = useCheckUserRole(Role.Admin);
  const [adding, setAdding] = useState(false);

  return (
    <PageContainer
      title={t("Card programs")}
      subtitle={t("CardProgramsDescription")}
      breadcrumbs={breadcrumbs}
      primaryAction={
        isAdmin && (
          <Button onClick={() => setAdding(true)}>
            {t("Add card program")}
          </Button>
        )
      }
    >
      <CardProgramsTable adding={adding} onAddClose={() => setAdding(false)} />
    </PageContainer>
  );
};

export default CardPrograms;
